import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import DraggableList from "../../common/components/draggableList/DraggableList";
import { AppState } from "../../root/RootReducer";
import {
    UpdateRecVideos,
    UpdateRecPrograms,
    UpdateRecProfessionals,
    GetRecVideoList,
    GetRecommendProfessionalList,
    GetRecommendProgramList,
} from "../../common/homePage/HomePageActions";
import { CircularProgress, createTheme, ThemeProvider } from "@material-ui/core";
import PuiTypography from "../../components/elements/PuiTypography";
import styles from "./EditRecommend.module.css";
import PuiFloatButton from "../../components/elements/PuiFloatButton";

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            // flexGrow: 1,
            display: "flex",
            justifyContent: "space-around",
            height: "83vh",
        },
        noContent: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
        },
    })
);

const theme = createTheme({
    palette: {
        secondary: {
            main: "#12e07e",
        },
    },
});
interface EditRecommendProps {
    setIsSaved: (isSaved: boolean) => void;
    isSaved: boolean;
}

export default function EditRecommend({ setIsSaved, isSaved }: EditRecommendProps) {
    const { userInfo } = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo,
    }));

    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (userInfo) {
            dispatch(GetRecommendProgramList(userInfo.id));
            dispatch(GetRecVideoList(userInfo.id));
            dispatch(GetRecommendProfessionalList(Number(userInfo.id)));
        }
    }, [dispatch, userInfo]);

    const { recommendVideoList, isLoading } = useSelector(
        ({ recommendList }: AppState) => recommendList
    );
    // const { recommendProgramList } = useSelector(({ recommendList }: AppState) => recommendList);
    const { recommendProfessionalList } = useSelector(
        ({ recommendList }: AppState) => recommendList
    );

    // 更新予定リストの枠
    const [recVideos, SetRecVideos] = useState<string[]>([]);
    const [recPrograms, SetRecPrograms] = useState<string[]>([]);
    const [recProfessionals, SetRecProfessionals] = useState<string[]>([]);

    // 更新したかどうかのフラグ
    const [isEditVideo, ChangeVideoFlag] = useState(false);
    const [isEditProgram, ChangeProgramFlag] = useState(false);
    const [isEditProfessional, ChangeProfessionalFlag] = useState(false);

    // 更新ボタンの有無効制御
    const [isReadyToUpdate, ChangeReadyToSendFlag] = useState(false);
    useEffect(() => {
        if (!isSaved) {
            ChangeReadyToSendFlag(false);
        } else {
            ChangeReadyToSendFlag(true);
        }
    }, [isSaved]);

    // 各おすすめリストの更新
    const handleUpdate = (targetId: string, list: any) => {
        // 更新されたリストをセット
        const updateList = [];
        for (let i = 0; i < list.length; i++) {
            const element = String(list[i].id);
            updateList.push(element);
        }

        setIsSaved(false);
        // 更新対象をセット
        switch (targetId) {
            case "video":
                SetRecVideos(updateList);
                ChangeVideoFlag(true);
                break;
            case "program":
                SetRecPrograms(updateList);
                ChangeProgramFlag(true);
                break;
            case "professional":
                SetRecProfessionals(updateList);
                ChangeProfessionalFlag(true);
                break;
        }
    };

    // 更新ボタンを効果
    const handleSubmit = () => {
        if (isEditVideo && userInfo) {
            dispatch(UpdateRecVideos(recVideos, userInfo.id));
            ChangeVideoFlag(false);
        }
        if (isEditProgram) {
            if (userInfo) dispatch(UpdateRecPrograms(recPrograms, userInfo.id));
            ChangeProgramFlag(false);
        }
        if (isEditProfessional) {
            dispatch(UpdateRecProfessionals(recProfessionals));
            ChangeProfessionalFlag(false);
        }
        setIsSaved(true);
    };

    // 表示待機
    if (isLoading) {
        return (
            <div className={classes.noContent}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <>
            <div className={classes.root}>
                <div className={styles.list}>
                    <div className={styles.listTitle}>
                        <PuiTypography size={24} bold={true} color={"black"}>
                            おすすめVideo
                        </PuiTypography>
                    </div>
                    <DraggableList
                        type="video"
                        targetList={recommendVideoList}
                        onUpdate={handleUpdate}
                        listHeight={500}
                    />
                </div>
                {/* <div className={styles.list}>
                    <div className={styles.listTitle}>
                        <PuiTypography size={24} bold={true} color={"black"}>
                            おすすめChannel
                        </PuiTypography>
                    </div>
                    <DraggableList
                        type="program"
                        targetList={recommendProgramList}
                        onUpdate={handleUpdate}
                        listHeight={500}
                    />
                </div> */}
                <div className={styles.list}>
                    <div className={styles.listTitle}>
                        <PuiTypography size={24} bold={true} color={"black"}>
                            おすすめPresenter
                        </PuiTypography>
                    </div>
                    <DraggableList
                        type="professional"
                        targetList={recommendProfessionalList}
                        onUpdate={handleUpdate}
                        listHeight={500}
                    />
                </div>
                <ThemeProvider theme={theme}>
                    <div className={styles.updateButton}>
                        <PuiFloatButton
                            children={["　更新　"]}
                            size="medium"
                            isActive={!isReadyToUpdate}
                            onClick={handleSubmit}
                        />
                    </div>
                </ThemeProvider>
            </div>
        </>
    );
}
